import { Env } from '../../../sites/types';

/**
 * Returns whether or not the current environment is the perf environment.
 * Extracted to a util to simplify testing but also to isolate for later
 * improvement as, honestly, checking the sanityDataset does not feel like
 * a super-robust solution. It was just all I could find.
 *
 */
export const isPerformanceEnv = (env: Env): boolean => {
  return env.sanityDataset === 'performance';
};
